import { IconSvgProps } from "@modules/ui/components/huButtonIcon"

export const DuplicateIcon: React.FC<IconSvgProps> = (props) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M1.67308 7.87172L11.9878 2.69954L22.3025 7.87172L11.9878 13.0439L1.67308 7.87172ZM22.3958 7.9185C22.3958 7.9185 22.3958 7.9185 22.3958 7.91849L22.3958 7.9185ZM1.57978 7.82493C1.57978 7.82493 1.57978 7.82493 1.57979 7.82494L1.57978 7.82493Z"
      stroke={props.color}
      strokeWidth="1.5"
      strokeLinecap="round"
    />
    <path
      d="M22.1816 12.1931L12.3078 17.2892C12.107 17.3928 11.8686 17.3928 11.6678 17.2892L1.79395 12.1931"
      stroke={props.color}
      strokeWidth="1.5"
      strokeLinecap="round"
    />
    <path
      d="M22.1816 16.1084L12.3078 21.2045C12.107 21.3081 11.8686 21.3081 11.6678 21.2045L1.79395 16.1084"
      stroke={props.color}
      strokeWidth="1.5"
      strokeLinecap="round"
    />
  </svg>
)
